module.exports = __webpack_public_path__ + "img/24.c8bbb6f8.webp";